import { Button } from '@/components/ui/button';
import type { CommonSkuCoverage } from './salesTrendChartData';

/** 累積推移グラフの母集団モード */
export type SalesTrendMode = 'per-pattern' | 'common';

/** {@link SalesTrendModeToggle} の Props */
export interface SalesTrendModeToggleProps {
  /** 現在のモード */
  mode: SalesTrendMode;
  /** 共通 SKU モードのカバレッジ。共通モード時のみ注記として表示する */
  coverage?: CommonSkuCoverage;
  /** モード切替 */
  onChange: (mode: SalesTrendMode) => void;
}

/**
 * 母集団モードの切替トグルと、共通 SKU モード時のカバレッジ注記。
 *
 * 共通 SKU モードは一部の SKU を除外して比較するため、どれだけ除外しているかと、
 * パラメータ比較表の WMAPE とは母集団が異なることを常時明示する。
 */
export function SalesTrendModeToggle({
  mode,
  coverage,
  onChange,
}: SalesTrendModeToggleProps): React.ReactElement {
  const isCommon = mode === 'common';

  return (
    <div className="mb-2">
      <div className="flex flex-wrap gap-2">
        <Button
          size="sm"
          variant={isCommon ? 'outline' : 'default'}
          aria-pressed={!isCommon}
          onClick={() => onChange('per-pattern')}
        >
          各パターンの母集団
        </Button>
        <Button
          size="sm"
          variant={isCommon ? 'default' : 'outline'}
          aria-pressed={isCommon}
          onClick={() => onChange('common')}
        >
          共通 SKU のみ
        </Button>
      </div>
      {isCommon && coverage && (
        <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground">
          <span>
            共通 {coverage.commonSkuCount.toLocaleString()} SKU（最大母集団{' '}
            {coverage.maxSkuCount.toLocaleString()} SKU の {coverage.coveragePercent.toFixed(1)}%。
            {/* カバレッジ差を見落とすと「精度は良いが対象SKUが少ない」条件を選んでしまうため強調する */}
            <span className="font-semibold text-amber-700 dark:text-amber-500">
              {coverage.excludedSkuCount.toLocaleString()} SKU を除外中
            </span>
            ）
          </span>
          <span>パラメータ比較表の WMAPE は各パターンの母集団ベースのままです</span>
        </div>
      )}
    </div>
  );
}
